// @flow
import Input from './Input';
import type { InputProps } from './Input';

export default Input;
export type { InputProps };
